import { api } from '@/lib/api';

const unwrap = (p) => p.then((r) => r.data);
const MP = { headers: { 'Content-Type': 'multipart/form-data' } };

/**
 * Modulo Immobiliare "Case in vendita" (admin-only + vetrina pubblica).
 * I documenti riservati (atto/visura/proprietari) sono gestiti solo lato admin.
 */
export const realEstateService = {
  // ---- Admin ----
  adminList: () => unwrap(api.get('/admin/real-estate')),
  create: (body) => unwrap(api.post('/admin/real-estate', body)),
  update: (id, body) => unwrap(api.patch(`/admin/real-estate/${id}`, body)),
  remove: (id) => unwrap(api.delete(`/admin/real-estate/${id}`)),
  addPhoto: (id, file) => { const fd = new FormData(); fd.append('file', file); return unwrap(api.post(`/admin/real-estate/${id}/photo`, fd, MP)); },
  addPhotoUrl: (id, url, alt) => unwrap(api.post(`/admin/real-estate/${id}/photo-url`, { url, alt: alt || '' })),
  removePhotoByUrl: (id, url) => unwrap(api.post(`/admin/real-estate/${id}/photo-remove`, { url })),
  delPhoto: (id, gid) => unwrap(api.delete(`/admin/real-estate/${id}/photo/${gid}`)),
  addDocument: (id, file, title, kind) => {
    const fd = new FormData(); fd.append('file', file); fd.append('title', title || ''); fd.append('kind', kind || 'altro');
    return unwrap(api.post(`/admin/real-estate/${id}/document`, fd, MP));
  },
  delDocument: (id, docId) => unwrap(api.delete(`/admin/real-estate/${id}/document/${docId}`)),
  leads: () => unwrap(api.get('/admin/real-estate/leads/all')),
  markLead: (id, handled) => unwrap(api.patch(`/admin/real-estate/leads/${id}`, { handled })),
  // ---- Pubblico ----
  publicList: () => unwrap(api.get('/public/real-estate')),
  publicDetail: (id) => unwrap(api.get(`/public/real-estate/${id}`)),
  submitLead: (id, body) => unwrap(api.post(`/public/real-estate/${id}/lead`, body)),
};

export default realEstateService;
